<template>
  <b-card no-body>
    <b-card-header class="container">
      <b-row>
        <b-col class="text-left">{{ moduleName }}</b-col>
        <b-col class="font-weight-bold">{{question.question_num}}/12</b-col>
        <b-col class="text-right"><span id="question-info" class="text-primary">Besoin d'aide &nbsp;<b-icon v-if="info[question.question_type]" icon="question-circle" variant="primary" scale="1.4"></b-icon></span></b-col>
      </b-row>
        <b-popover
          v-if="info[question.question_type]"
          target="question-info"
          placement="bottomleft"
          triggers="hover focus"
          :title="info[question.question_type].title"
        >
          <pre class="question-info-text">{{ info[question.question_type].text }}</pre>
        </b-popover>
    </b-card-header>
    <b-card-body class="text-center">
      <b-card-title>
        {{ question.question_title }}
      </b-card-title>
      <drag-and-drop-list v-if="question.question_type=='DDL'" :question="question" @update-selected="setSelected"></drag-and-drop-list>
      <drag-and-drop-sort v-else-if="question.question_type=='DDS'" :question="question" @update-selected="setSelected"></drag-and-drop-sort>
      <drag-and-drop-pair v-else-if="question.question_type=='DDP'" :question="question" @update-selected="setSelected"></drag-and-drop-pair>
      <hotspot v-else-if="question.question_type=='hotspot'" :question="question" :encodedFile="file" @update-selected="setSelected"></hotspot>
      <mcq v-else-if="question.question_type=='4QV' || question.question_type=='2Qx2Q'" :question="question" :encodedFile="file" @update-selected="setSelected"></mcq>
<!--       
      <p v-for="answer in question.answers" :key="answer.id">{{answer}}</p>
      <b-button  :to="{ name: 'Question', params: { id: parseInt(this.$route.params.id)+1 }}">Suivante</b-button>
       -->

      <div class="button-group">
        <b-button class="nav-button col-xs-6 col-md-4 col-xl-3" variant="danger" :to="{ name: 'Dashboard' }">Mettre l'exercice en pause</b-button>
        <b-button class="nav-button col-xs-6 col-md-4 col-xl-3 text-white" :disabled="selected === null" variant="success" @click="onClick">Valider ma réponse</b-button>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import DragAndDropList from '@/components/questions/DragAndDropList.vue'
import DragAndDropSort from '@/components/questions/DragAndDropSort.vue'
import DragAndDropPair from '@/components/questions/DragAndDropPair.vue'
import Hotspot from '@/components/questions/Hotspot.vue'
import Mcq from '../components/questions/MCQ.vue'
import api from '@/services/api.js'
export default {
    components: {
        DragAndDropList,
        DragAndDropSort,
        DragAndDropPair,
        Hotspot,
        Mcq,
    },
  data () {
    return {
        selected: null,
        question: {},
        exam: {},
        moduleName: '',
        file: '',
        info: {
          "2Qx2Q": {
            title: 'Question à choix multiple',
            text: 'Veuillez sélectionner votre réponse parmi les propositions données, avant de valider votre réponse.'
          },
          "4QV": {
            title: 'Question illustrée à choix multiple',
            text: 'Veuillez sélectionner votre réponse parmi les propositions en vous aidant de l\'image d\'illustation, avant de valider votre réponse.'
          },
          "hotspot": {
            title: 'Hotspot',
            text: 'Veuillez cliquer à l\'emplacement de l\'image que vous considérez être la bonne réponse. \nIl peut exister plusieurs bonnes réponses possibles pour une même question.'
          },
          "DDL": {
            title: 'Liste par glisser-déposer',
            text: 'Veuillez glisser-déposer toutes les bonnes réponses de la liste "Propositions" dans l\'encadré "Vos réponses". \n\nPour cela, cliquez sur l\'une des réponses de votre choix, et en maintenant votre clique, déplacez la souris jusque dans l\'encadré "Vos réponses". \nVous pouvez alors relâcher votre clique, la réponse a été déplacée. \n\nLe nombre de bonnes réponses est compris entre 1 et 4.'
          },
          "DDS": {
            title: 'Classement par glisser-déposer',
            text: 'Veuillez ordonner l\'ensemble des propositions. \n\nPour cela, vous devez cliquer sur la proposition que vous souhaitez déplacer. En maintenant votre clique, faites monter ou descendre la proposition dans la liste jusqu\'à l\'emplacement souhaité. \nVous pouvez alors relacher votre clique, la proposition a été déplacée.'
          },
          "DDP": {
            title: 'Association par glisser-déposer',
            text: 'Veuillez associer chacune des propositions affichées à l\'un des encadrés de réponse. \n\nPour cela, vous devez cliquer sur l\'une des réponses que vous souhaitez déplacer. En maintenant votre clique déplacez la souris jusque dans l\'encadré de votre choix. Vous pouvez alors relâcher votre clique, la réponse a été déplacée. \n\nChaque encadré de réponse doit contenir une réponse pour être validée.'
          },

        }
    }
  },
  computed: {
    examData() { 
      return {
        question: this.question.id,
        exam: this.exam.id,
        userAnswer: this.selected,
      }
    }
  },
  methods: {
    noAnswer() {
        this.$bvModal.msgBoxOk("Veuillez sélectionner une réponse avant de passer à la question suivante.", {
          title: 'Aucune réponse enregistrée.',
          size: 'md',
          buttonSize: 'md',
          okVariant: 'success',
          headerClass: 'p-2 border-bottom-0',
          footerClass: 'p-2 border-top-0',
          centered: true
        })
      },

    setSelected (payload) {
        this.selected = payload
    },

    getNextQuestion() {
      this.$parent.$parent.setLoading(true, "Chargement de la prochaine question")
      api.get('/question/next/'+parseInt(this.$route.params.id))
      .then(response => {
        this.question = response.data[0]['question']
        this.exam = response.data[0]['exam']
        this.moduleName = this.exam.module.name
        this.file = response.data[0]['file']
        this.$parent.$parent.setLoading(false)
      })
      .catch(error => {
        if (error.response.status == 303) {
          this.$parent.$parent.setLoading(false)
          this.$router.push({ 
            name: "Result", 
            id: this.$route.params.id
          })
        }
        else if (error.response.status == 404 || error.response.status == 403) {
          this.$router.push({name: "Dashboard"})
        }
      })
    },

    onClick() {
      if(this.selected === null || this.selected === "") {
        this.noAnswer()
        return
      }
      this.$parent.$parent.setLoading(true, "Enregistrement de votre réponse")
      new Promise((resolve, reject) =>
        api.post('/exam/data/new', this.examData)
      .then(resp => {
        this.getNextQuestion()
        this.selected=null
        resolve(resp)
      })
      .catch(error => {
        if (error.response.status == 403 || error.response.status == 404) {
          this.getNextQuestion()
          this.selected=null
        }
        if (error.response.status == 500) {
          this.$parent.$parent.setLoading(false)
          this.noAnswer()
        }
        reject(error)
      }))
    }
  },
  created() {
    this.getNextQuestion()
  },
}
</script>

<style scoped>
.card-title {
    margin-bottom: 2rem
}
.header {
  display: flex;
  justify-content: space-between
}
#btn-radios {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin: 1.5rem auto 0;
    width: 100%;
}
.radioButton {
    display: grid;
    align-items: center;
    width:100%;
    font-size: 0.9em;
    margin: 0.7rem;
    min-height: 11rem;
}
.response-container {
    display: grid;
}
.button-group {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 2rem
}
.nav-button {
    min-height: 5rem;
    max-width: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
}
#question-info{
  cursor: help
}
.question-info-text {
  white-space: pre-wrap;
}
</style>